import { HiDotsVertical } from "react-icons/hi";
import { useRef, useEffect } from "react";
import ActionMenu from "@components/menus/ActionMenu";

export default function FormCard({
  name,
  fillable_at_home,
  index,
  isOpen,
  onToggle,
  closeMenu,
  onDelete,
  onEdit,
}) {
  const menuRef = useRef();
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        closeMenu();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [closeMenu]);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    onToggle();
  };

  return (
    <div
      className="dashboard-card group p-5 cursor-pointer w-full animate-fade-in-up"
      style={{
        opacity: 0,
        animationDelay: `${index * 0.05}s`,
        animationFillMode: 'forwards'
      }}
    >
      <div className="flex items-center gap-4">
        {/* Form Icon */}
        <div className="relative flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200/60 flex items-center justify-center shadow-sm group-hover:shadow-md group-hover:scale-105 transition-all duration-300">
          <svg
            className="w-6 h-6 text-slate-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          {/* PDF corner fold */}
          <div className="absolute -top-0.5 -right-0.5 w-3 h-3">
            <div className="w-full h-full bg-gradient-to-br from-red-400 to-red-500 rounded-bl-lg rounded-tr-lg shadow-sm"></div>
          </div>
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <p
            className="font-semibold text-slate-800 truncate group-hover:text-slate-900 transition-colors"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            {name}
          </p>
          {fillable_at_home ? (
            <div className="badge badge-success mt-2">
              <svg
                className="w-3.5 h-3.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              <span>Remote Fill</span>
            </div>
          ) : (
            <div className="flex items-center gap-1.5 mt-2">
              <div className="w-2 h-2 rounded-full bg-slate-300"></div>
              <span className="text-xs text-slate-400" style={{ fontFamily: 'var(--font-body)' }}>
                In-clinic only
              </span>
            </div>
          )}
        </div>

        {/* Menu button */}
        <div
          className="relative flex-shrink-0"
          ref={menuRef}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={handleMenuToggle}
            className="p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 opacity-0 group-hover:opacity-100"
          >
            <HiDotsVertical className="w-5 h-5" />
          </button>
          {isOpen && <ActionMenu index={index} onDelete={onDelete} onEdit={onEdit} />}
        </div>
      </div>

      {/* Bottom accent line (appears on hover) */}
      <div className="absolute bottom-0 left-4 right-4 h-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </div>
  );
}
